import { useState } from 'react';

export function useMap<Key extends keyof any, Value>(
  initialValue: Map<Key, Value> = new Map()
) {
  const [map, setMap] = useState<Map<Key, Value>>(initialValue);

  const setValue = (key: Key, value: Value): void => {
    setMap((prev) => new Map(prev).set(key, value));
  };

  const getValue = (key: Key): Value | undefined => {
    return map.get(key);
  };

  const getAllValues = (): Array<Value> => {
    return Array.from(map.values());
  };

  const getAllKeys = (): Array<Key> => {
    return Array.from(map.keys());
  };

  const getAllEntries = (): Array<[Key, Value]> => {
    return Array.from(map.entries());
  };

  const clear = (key: Key): void => {
    setMap((prev) => {
      const next = new Map(prev);
      next.delete(key);
      return next;
    });
  };

  const clearAll = (): void => {
    setMap(new Map());
  };

  const hasKey = (key: Key): boolean => {
    return map.has(key);
  };

  const isEmpty = () => {
    return map.size === 0;
  };

  return {
    setValue,
    getValue,
    getAllValues,
    getAllKeys,
    getAllEntries,
    hasKey,
    clear,
    clearAll,
    isEmpty,
  };
}
